import { Avatar, Button, Typography } from '@mui/material';
import styled from '@emotion/styled';
import Expanded from '../../../../components/Expanded';
import { useSignOut } from '../../../../hooks/auth';
import { useUser } from '../../../../hooks/user';

export default function HeaderBar() {
  const signOut = useSignOut();
  const user = useUser();

  console.log(user);

  return (
    <Root>
      <Expanded />
      <UserInfo>
        <Avatar
          sx={{
            width: 32,
            height: 32,
          }}
        />
        <Typography variant="body1">{user?.name || user?.email}</Typography>
      </UserInfo>
      <Button variant="contained" size="small" onClick={signOut}>
        Sign out
      </Button>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.palette.primary.main};
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.common.white};
  gap: ${({ theme }) => theme.spacing(4)};
`;

const UserInfo = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
`;
